<template>
  <div class="app-input">
    <div
      v-if="label"
      class="text-14-400 text-dark flex items-center label-input"
    >
      <div class="col-xs">{{ label }}</div>
    </div>
    <q-input
      ref="input"
      :class="{
        'dense-input': dense,
        'prepend-border': $slots.prepend,
        'borderless': borderless,
        'textarea': type === 'textarea',
      }"
      :hint="hint"
      :placeholder="placeholder"
      :rules="rules"
      :value="value"
      :type="type"
      :rows="rows"
      no-error-icon
      outlined
      hide-bottom-space
      :bg-color="bgColor"
      v-bind="$attrs"
      @blur="$emit('blur', $event)"
      @clear="$emit('clear', $event)"
      @click="$emit('click', $event)"
      @focus="$emit('focus', $event)"
      @keyup="$emit('keyup', $event)"
      @input="onInput"
    >
      <template v-slot:append>
        <slot name="append"/>
      </template>
      <template v-slot:before>
        <slot name="before"/>
      </template>
      <template v-slot:prepend>
        <slot name="prepend"/>
      </template>
      <template v-slot:after>
        <slot name="after"/>
      </template>
      <template
        v-if="hasProperty($attrs, 'bottom-slots') && !$slots.error"
        #error="error"
      >
        <slot
          name="error"
          v-bind="error"
        />
      </template>
      <template
        v-if="hasProperty($attrs, 'bottom-slots') && $slots.hint"
        #hint="data"
      >
        <slot
          name="hint"
          v-bind="{ ...data, hint }"
        />
      </template>
    </q-input>
  </div>
</template>

<script>
import { hasProperty } from '../helpers/objectHelper';

export default {
  name: 'AppInput',
  props: {
    value: {
      type: [String, Number],
      default: undefined,
    },
    label: {
      type: String,
      default: undefined,
    },
    bgColor: {
      type: String,
      default: 'white',
    },
    type: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: undefined,
    },
    hint: {
      type: String,
      default: undefined,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    borderless: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: undefined,
    },
    expandable: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    hasProperty,
    onInput(event) {
      if (this.type === 'textarea' && this.expandable) {
        const textarea = document.querySelector('textarea');
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
      }

      this.$emit('input', event);
    },
    focus() {
      this.$refs.input.$refs.input.focus();
    },
    validate() {
      return this.$refs.input.validate();
    },
  },
};
</script>

<style lang="scss" scoped>
.app-input {
  .label-input {
    height: 50px;
  }

  .dense-input {
    ::v-deep .q-field__control {
      height: auto !important;
    }
  }

  .q-textarea {
    ::v-deep .q-field__control {
      height: auto !important;
    }

    ::v-deep .q-field__native {
      resize: vertical !important;
      appearance: none !important;
      resize: none !important;
      overflow-y: hidden !important;
      line-height: 1 !important
    }
  }

  ::v-deep .q-field {
    &__bottom {
      padding: 8px 0;
    }

    &__prepend,
    &__before {
      padding-right: 0;
    }

    &--error {
      .q-icon {
        color: $negative !important;
      }
    }

    &__messages {
      color: currentColor !important;
    }

    &__marginal {
      height: auto;
      color: inherit !important;
    }

    &--outlined {
      .q-field__control {
        border-radius: $radius-6;
        padding: 0 18px;
        height: 50px;

        &:before {
          border: 1px solid $grey-2;
        }
      }
    }
  }

  ::v-deep .q-placeholder {
    &::placeholder {
      color: $grey !important;
      opacity: 1 !important;
    }
  }

  .borderless {
    ::v-deep {
      .q-field__control {
        padding: 0 !important;

        &:before, &:after {
          border: none !important;
        }
      }
    }
  }
}

</style>
